import { FC, useState, useCallback, Fragment } from 'react'
import { Card } from './card'
import update from 'immutability-helper'
import React from 'react'
import styles from './comp.module.css'; // Import css modules stylesheet as styles
import { Button, Divider, Dropdown, Grid } from 'semantic-ui-react';
import { RequirementFlags } from '../../enumerable/RequirementFlags';


const style = {
  width: 400,
}

export interface Item {
  id: number
  text: string
}

export interface ContainerState {
  cards: Item[]
}

interface props {
  items: string[];
  getNewValue: (value: string) => void
}

export const Container: FC<props> = ({ items, getNewValue }) => {
  {
    const [cards, setCards] = useState(

      items.map((val, inx) => {
        return { id: inx, text: val };
      })
    )

    const [selection, setSelection] = useState("")


    const moveCard = useCallback(
      (dragIndex: number, hoverIndex: number) => {
        const dragCard = cards[dragIndex]

        let newCards = update(cards, {
          $splice: [
            [dragIndex, 1],
            [hoverIndex, 0, dragCard],
          ],
        });
        setCards(
          newCards
        );
        getNewValue(JSON.stringify(newCards));
      },
      [cards],
    )

    const removeCard = useCallback(
      (Index: number) => {

        let newCards = update(cards, {
          $splice: [
            [Index, 1],
          ],
        });
        setCards(
          newCards
        );
        getNewValue(JSON.stringify(newCards));
      },
      [cards],
    )

    const addCard = (() => {
      let value: string = selection
      let newItem: Item = { id: cards.length, text: value };

      let newCards = update(cards, {
        $push: [newItem],
      });
      setCards(
        newCards
      );

      getNewValue(JSON.stringify(newCards));
    }
    )

    const HandleNewItem = (event: any, data: any) => {
      setSelection(data.value);
    }


    const renderCard = (card: { id: number; text: string }, index: number) => {
      return (
        <Card
          key={card.id}
          index={index}
          id={card.id}
          text={card.text}
          moveCard={moveCard}
          removeCard={removeCard}
        />
      )
    }

    return (
      <Fragment>
        <Grid columns={2}>
          <Grid.Column >
            <Dropdown
              placeholder='Select requirement'
              fluid
              search
              selection
              options={RequirementFlags}
              onChange={HandleNewItem}
            />
          </Grid.Column>
          <Grid.Column >
            <Button
              // loading={submitting}
              content={"Add Requirement"}
              labelPosition={'left'}
              icon={"plus circle"}
              floated={"right"}
              className={'rl-btn'}
              size={'tiny'}
              type='button'
              // disabled={disabled}
              onClick={addCard}
            />
          </Grid.Column>
        </Grid>
        <Divider />
        <div style={style} className={styles.Wrapper}> {cards.map((card, i) => renderCard(card, i))}</div>
      </Fragment>
    )
  }
}
